"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartAutoshipAll = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const translations_1 = require("../../i18n/translations");
const Image_1 = require("../Image");
function CartAutoshipAll(_a) {
    var { className, linkProps, linkClassName, handleAutoshipFunction, removeAutoship, autoShipTotal, allConfigItemsChecked, isAllCustomConfig, allConfigItems, locale = 'en' } = _a, props = __rest(_a, ["className", "linkProps", "linkClassName", "handleAutoshipFunction", "removeAutoship", "autoShipTotal", "allConfigItemsChecked", "isAllCustomConfig", "allConfigItems", "locale"]);
    const { autoshipAllSubscribe, autoshipAllSave, autoshipFrequencyLabel, autoshipQuarterly, autoshipMonth, autoshipMonths, } = translations_1.cartContent[locale];
    const [frequencyOption, setFrequencyOption] = (0, react_1.useState)(3);
    const toggleAutoshipInputIsOpen = (e) => {
        const { checked } = e.target;
        if (checked) {
            handleAutoshipFunction(frequencyOption);
        }
        else {
            removeAutoship();
        }
    };
    const handleFrequencyDropdown = (e) => {
        const { value } = e.target;
        if (!allConfigItemsChecked) {
            setFrequencyOption(value);
        }
        else {
            setFrequencyOption(value);
            handleAutoshipFunction(value);
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (!isAllCustomConfig) {
            setFrequencyOption('quarterly');
        }
        else {
            const findSingleCustomItem = (_a = allConfigItems[0].configurationOptions) === null || _a === void 0 ? void 0 : _a.find((el) => el.configId === 'autoship.frequency');
            setFrequencyOption(findSingleCustomItem.configValue || '1');
        }
    }, [isAllCustomConfig, allConfigItems]);
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)('w-full bg-gray-fa border border-gray-e max-w-full mx-auto mb-4 py-1 px-4 text-gray rounded-xl flex flex-wrap md:flex-nowrap md:flex-row md:justify-between') }, props),
        react_1.default.createElement("div", { className: "shrink self-center pl-8" },
            react_1.default.createElement("label", { htmlFor: "autoship-all-input", className: "pt-2 -mt-0.5 pr-8 mb-1 relative inline-block" },
                react_1.default.createElement("input", { id: "autoship-all-input", className: "block absolute -left-8 top-3 rounded border border-borderColor inline-block cursor-pointer", type: "checkbox", onChange: (e) => {
                        toggleAutoshipInputIsOpen(e);
                    }, checked: allConfigItemsChecked, "data-testid": "autoship-all-checkbox" }),
                react_1.default.createElement("span", { className: "inline-block" },
                    react_1.default.createElement(Image_1.Image, { className: "h-7 inline-block mr-2", src: "/as-logo-icon-91x70?fmt=png-alpha", alt: "" }),
                    react_1.default.createElement("span", { className: "font-bold" }, autoshipAllSubscribe),
                    ' ',
                    react_1.default.createElement("span", { className: "font-bold" }, autoShipTotal),
                    " ",
                    autoshipAllSave))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('grow md:grow-0 whitespace-nowrap transition-opacity', {
                'opacity-50': !isAllCustomConfig || allConfigItemsChecked,
            }) },
            react_1.default.createElement("label", { htmlFor: "autoship-all__freq-select", className: "inline-block mr-2" }, autoshipFrequencyLabel),
            react_1.default.createElement("select", { id: "autoship-all__freq-select", className: (0, classnames_1.default)('inline-block rounded border border-borderColor text-sm py-2 pl-3 pr-10', {
                    'cursor-not-allowed': !isAllCustomConfig || allConfigItemsChecked,
                }), disabled: isAllCustomConfig && !allConfigItemsChecked ? false : true, value: frequencyOption, key: "autoship-dropdown", onChange: handleFrequencyDropdown },
                !isAllCustomConfig && (react_1.default.createElement("option", { value: "quarterly" }, autoshipQuarterly)),
                react_1.default.createElement("option", { value: 1 },
                    "1 ",
                    autoshipMonth),
                react_1.default.createElement("option", { value: 3 },
                    "3 ",
                    autoshipMonths),
                react_1.default.createElement("option", { value: 6 },
                    "6 ",
                    autoshipMonths),
                react_1.default.createElement("option", { value: 9 },
                    "9 ",
                    autoshipMonths),
                react_1.default.createElement("option", { value: 12 },
                    "12 ",
                    autoshipMonths)))));
}
exports.CartAutoshipAll = CartAutoshipAll;
